var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('bim-input',{staticClass:"mb-6",attrs:{"placeholder":"Поиск по регионам"},model:{value:(_vm.filter),callback:function ($$v) {_vm.filter=$$v},expression:"filter"}}),_vm._v(" "),_c('tree',{ref:"tree",staticClass:"regions-list tree--small",attrs:{"filter":_vm.filter,"data":_vm.parseRegionsArray,"options":_vm.treeOptions}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }